import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'
// import * as XLSX from 'xlsx'
import '@/styles/index.scss' // global css
// main.js
import htmlToPdf from '@/utils/htmlToPdf'
import { parseTime } from '@/utils/index'
import * as filters from '@/utils/filters'

import App from './App'
import router from './router'
import store from './store'

import '@/icons' // icon
import '@/permission' // permission control

Vue.use(ElementUI, { locale })
Vue.use(VCharts)
Vue.use(htmlToPdf)

// 注册全局过滤器
Vue.filter('parseTime', parseTime)
Vue.filter('timeFilter', filters.timeFilter)
Vue.filter('dateFilter', filters.dateFilter)
Vue.filter('timeOnlyFilter', filters.timeOnlyFilter)
Vue.filter('datetimeFilter', filters.datetimeFilter)
Vue.filter('chineseDateFilter', filters.chineseDateFilter)
Vue.filter('chineseDatetimeFilter', filters.chineseDatetimeFilter)
Vue.filter('relativeTimeFilter', filters.relativeTimeFilter)
Vue.filter('weekFilter', filters.weekFilter)
Vue.filter('monthFilter', filters.monthFilter)
Vue.filter('quarterFilter', filters.quarterFilter)
Vue.filter('ageFilter', filters.ageFilter)
Vue.filter('durationFilter', filters.durationFilter)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js